module.exports = __webpack_public_path__ + "17a647895615cd805d95d4eaedf3a72f.svg";